module.exports = __webpack_public_path__ + "img/banner-11e.fce7cf77.png";